<!-- eslint-disable vue/no-v-html -->
<template>
  <ul :class="['PageMessages', { 'PageMessages--sticky': alertStore.sortedMessages.length }]">
    <SlideDownTransition group>
      <li
        v-for="message in alertStore.sortedMessages"
        :key="`${message.body}-${message.timestamp}`"
        :class="`
          PageMessages__message PageMessages__message--left
          PageMessages__message--${message.type || 'default'}`"
      >
        <span>{{ $tr(message.body, message.args) }}</span>
      </li>
    </SlideDownTransition>
  </ul>
</template>

<script>
export default {
  setup() {
    const alertStore = useAlertStore()

    return { alertStore }
  },

  data: () => ({
    mounted: false,
  }),

  mounted() {
    this.startPolling()
    this.$nextTick(() => {
      this.mounted = true
    })
  },

  beforeUnmount() {
    this.stopPolling()
  },

  methods: {
    startPolling() {
      this.pollingInterval = setInterval(this.poll, 500)
    },
    stopPolling() {
      clearInterval(this.pollingInterval)
    },
    poll() {
      // Check if any messages are older than the limit
      if (this.alertStore.sortedMessages.length) {
        this.alertStore.CLEAN_MESSAGES()
      }
    },
  },
}
</script>

<style lang="postcss">
.PageMessages {
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;

  &--sticky {
    @apply z-[110];
    position: sticky;
    width: 100%;
    top: 0;
  }

  &__message {
    list-style: none;
    margin: 0;
    position: relative;
    color: theme('colors.white');
    text-align: center;
    padding: 15px 40px;

    &--success {
      background-color: #41b675;
    }

    &--error {
      background-color: #ff3128;
    }

    &--default {
      background-image: var(--gradient-default);
    }

    &--left {
      text-align: left;
    }

    &--with-line-link {
      padding-bottom: 20px;
    }
  }

  &__close {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    line-height: 50px;
    padding: 0 20px;
    color: theme('colors.white');
  }
}
</style>
